<template>
  <div>
    <navMenu />

    <hero :heroTitle="$t('demodayPage.title')" class="pb-0"/>

    <section class="jsk-block pt-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 col-md-12 text-center">
            <p>{{ $t("demodayPage.subtitle") }}</p>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("demodayPage.age") }}</span>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("demodayPage.level") }}</span>
            <span class="badge badge-pill bg-black mr-2">{{ $t("demodayPage.price") }}</span>
          </div>
        </div>
      </div>
    </section>

     <courseDetails 
    :scheduleText="$t('demodayPage.schedule')"
    :locationText="$t('demodayPage.location')"
    :priceText="$t('demodayPage.priceDetails')"
   />

    <cta :ctaText="$t('cta.demodayTextClosed')" :ctaBtn="$t('cta.demoDayBtnCourses')" :ctaRoute="'/courses'" />
    
    <featured />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import courseDetails from "./../components/courseDetails.vue";
import cta from "./../components/cta.vue";
import featured from "./../components/featured.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "DemoDay",
  components: {
    navMenu,
    courseDetails,
    cta,
    featured,
    hero,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
